
function initRegion(region) {
    $.get( "/checkout/county", function( data ) {
        $(region).each(function(){
            var currentRegion = $(this);
            var previousValue = currentRegion.data('value');
            $.each(data, function (i, variable) {
                var option = $('<option>', {value: variable, text: variable});
                if(previousValue == variable){
                    option.prop('selected', true);
                }
                if (currentRegion.find("option[value='" + variable + "']").length == 0){
                  currentRegion.append(option);
                }
            });
       });
    });
    region.select2();
}
function initTown(region, town){
    initSelect(town);

    region.on('change', function(){
        var newRegion = $( this ).val();
        var currentTown = $(this).siblings("select:first");
        reset(currentTown);
        if(newRegion){
            currentTown.prop("disabled", false);
            $.get( "/checkout/city?county="+ newRegion, function( data ) {
                $.each(data, function (i, variable) {
                    var option = $('<option>', {value: variable, text: variable});
                    if(currentTown.find("option[value='" + variable + "']").length == 0){
                       currentTown.append(option);
                    }
                });
            });

        }
    });
    $(region).each(function () {
        var previousRegion = $(this).data('value');
        if(previousRegion){
            var currentTown = $(this).siblings("select:first");
            currentTown.prop("disabled", false);
            $.get( "/checkout/city?county="+ previousRegion, function( data ) {
                var previousValue = $(currentTown).data('value');
                $.each(data, function (i, variable) {
                    var option = $('<option>', {value: variable, text: variable});
                    if(previousValue === variable){
                        option.prop('selected', true);
                    }
                    if(currentTown.find("option[value='" + variable + "']").length == 0){
                        currentTown.append(option);
                    }
                });
            });
        }
    });

    town.select2();
}

function initPostalCode(region, town, postalCode){
    initSelect(postalCode);

    $(town).each(function () {
        var currentRegion = $(this).siblings("select:first");
        var currentTown = $(this);
        var currentPostalCode = $(this).nextAll("select:first");
        var previousRegion = $(currentRegion).data('value');
        var previousTown = $(currentTown).data('value');

        if (previousRegion && previousTown) {
            currentPostalCode.prop("disabled", false);
            var previousValue = currentPostalCode.data('value');
            $.get("/checkout/zip?county=" + previousRegion + "&city=" + previousTown, function (data) {
                var dataSize = data.length;
                if (dataSize === 1 && !previousValue) {
                    var option = $('<option>', {value: data[0], text: data[0], selected: true});
                    if(currentPostalCode.find("option[value='" + data[0] + "']").length == 0){
                       currentPostalCode.append(option);
                    }
                } else {
                    $.each(data, function (i, variable) {
                        var option = $('<option>', {value: variable, text: variable});
                        if(currentPostalCode.find("option[value='" + variable + "']").length == 0){
                           currentPostalCode.append(option);
                        }
                    });
                }
                if(previousValue) {
                    var selectedPostalCodeOption = $(currentPostalCode).find('option[value=' + previousValue + ']');
                    if (selectedPostalCodeOption.length) {
                        selectedPostalCodeOption.prop('selected', true);
                    } else {
                        selectedPostalCodeOption = $('<option>', {value: previousValue, text: previousValue});
                        selectedPostalCodeOption.prop('selected', true);
                        if($(currentPostalCode).find('option[value=' + previousValue + ']').length == 0){
                           currentPostalCode.append(selectedPostalCodeOption);
                        }
                    }
                }
            });
        }
    });

    region.on('change', function(){
        var currentPostalCode = $(this).nextAll("select:not(:first)");
        reset(currentPostalCode);
    });

    town.on('change', function(){
        var currentRegion = $(this).siblings("select:first");
        var currentTown = $(this);
        var currentPostalCode = $(this).nextAll("select:first");
        reset(currentPostalCode);
        if(currentRegion.val() && currentTown.val()){
            currentPostalCode.prop("disabled", false);
            $.get( "/checkout/zip?county="+ currentRegion.val() +"&city="+ currentTown.val(), function( data ) {
                var dataSize = data.length;
                    if(dataSize === 1){
                        var option = $('<option>', {value: data[0], text: data[0], selected:true});
                        if(currentPostalCode.find("option[value='" + data[0] + "']").length == 0){
                            currentPostalCode.append(option);
                        }
                } else {
                   $.each(data, function (i, variable) {
                       var option = $('<option>', {value: variable, text: variable});
                       if(currentPostalCode.find("option[value='" + variable + "']").length == 0){
                            currentPostalCode.append(option);
                       }
                   });
               }
            });
        }
    });
    postalCode.on('change', function (data) {

        var addressCode = $(data.currentTarget);
        var options = data.currentTarget.options;
        var errorMessage = addressCode.data('error-zip-message');

        var values = $.map(options, function(option) {
            return option;
        });

        var newZipCode = true;

        $.each(values, function (i, zip) {
            if ($(zip).data('select2-tag')) {
                return true;
            }

            if (addressCode.val() === '' || addressCode.val() === zip.value) {
                newZipCode = false;
            }
        });

        if (addressCode.val() === "") {
            newZipCode = false;
        }

        addressCode.siblings('.dangerMessage').remove();
        if (newZipCode) {
            addressCode.next()
                .after("<span class='dangerMessage'>" +errorMessage + "</span>");
        }
    });

    var replaceMap = {
        '\\': '&#92;',
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        '\'': '&#39;',
        '/': '&#47;'
    };

    postalCode.select2({
        tags: true,
        createTag: function (params) {
            var term = params.term;
            return {
                id: term.replace(/[&<>"'\/\\]/g, function (match) {
                    return replaceMap[match];
                }),
                text: term,
                newOption: true
            }
        }
    });
}

function isDefined(variable){
  return (typeof variable !== 'undefined') && (typeof variable.val() !== 'undefined');
}
function initSelect(select){
    select.each(function(){
        var options = $(this).find('option');
        if(options.length == 1){
            $(options).first().prop('selected', true);
            $(this).prop("disabled", true);
        }
    });
}
function reset(select){
    select.find('option:not(:first)').remove();
    select.find('option:first').prop('selected', true);
    select.prop("disabled", true);

}

function initSelect2forCountyTownPostalCode() {
    $(document).on("initSelect2forCountyTownPostalCodeInputs", function () {
        init();
    });
}

function init() {
    var region = $(".j-select-region");
    var town = $(".j-select-town");
    var postalCode= $(".j-select-zip");
    if( isDefined(region) && isDefined(town) && isDefined(postalCode) ){
        initRegion(region);
        initTown(region,town);
        initPostalCode(region, town,postalCode);

        $('.select2').find('.select2-selection').focus(function (e) {
            $(this).closest('.select2').prev('select').select2('open');
        });
    }
}

$(document).ready(function() {
    init();
    initSelect2forCountyTownPostalCode();
});